import axios from "@services/axios.service";

import "../assets/fonts/rubik.css"
import "./Root.css";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";

import Home from "./Pages/Home/Home";
import News from "./Pages/News/News";

import { DonatPage } from "@/pages/Donat";

import PersonalStatistics from "./Pages/PersonalStatistics/PersonalStatistics";
import Information from "./Pages/Information/Information";
import Error from "./Pages/Error/Error";

import Layout from "./Layout/Layout";


function createCurrentNumber(constParam, newParam) {
  let currentNumber = constParam;

  if (currentNumber === 0) {
    if (newParam > 1000 && newParam <= 2000) {
      currentNumber = 1000;
    } else if (newParam > 2000) {
      currentNumber = newParam - 2000;
    }
  }

  return currentNumber;
}

function settingRenderFunc(funcUpdateCurrentNumber, constParam, newParam) {
  let currentNumber = createCurrentNumber(constParam, newParam);
  let step = 1000 / Math.abs(currentNumber - newParam);

  if (currentNumber < newParam) {
    let intervalUp = setInterval(() => {

      if (currentNumber <= newParam && currentNumber > constParam) {
        funcUpdateCurrentNumber(currentNumber);
      }

      if (currentNumber > newParam) {
        clearInterval(intervalUp);
      }

      currentNumber++;
    }, step);

  } else {
    let intervalDown = setInterval(() => {

      if (currentNumber >= newParam && currentNumber < constParam) {
        funcUpdateCurrentNumber(currentNumber);
      }

      if (currentNumber < newParam) {
        clearInterval(intervalDown);
      }

      currentNumber--;
    }, step);
  }

}


const Root = () => {
  const [online, setOnline] = useState(0);
  const [sms, setSms] = useState(0);
  const [users, setUsers] = useState(0);
  const [days, setDays] = useState(0);

  const [newStat, setNewStat] = useState([0, 0, 0, 0]);

  const arrFunc = [setOnline, setSms, setUsers, setDays];
  let arrParam = [online, sms, users, days];

  const theme = useSelector((state) => state.theme);


  useEffect(() => {
    const interval = setInterval(async () => {
      let { data } = await axios.get("/updateStat");

      setNewStat((oldStat) => {
        let newStat = [
          Number(data.online),
          Number(data.users_sms),
          Number(data.users_count),
          Number(Math.floor((Date.parse(new Date) - Date.parse(data.createdAt)) / (1000 * 3600 * 24)))
        ];

        let flag = false;

        for (let i = 0; i < oldStat.length; i++) {
          if (newStat[i] !== oldStat[i]) {
            flag = true;
            break;
          }
        }

        if (flag) {
          return newStat;
        } else {
          return oldStat;
        }
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => { 
    arrParam.forEach((el, i) => {
      if (newStat[i] !== arrParam[i]) {
        settingRenderFunc(arrFunc[i], arrParam[i], newStat[i]);
      }
    });

  }, [newStat]);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("theme", theme);
    document.title = 'BFG';
  }, [theme]);

  
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home randerSettings={arrParam} />} />
          <Route path="/news" element={<News randerSettings={arrParam} />} />
          <Route path="/donat" element={<DonatPage />} />
          <Route path="/stat" element={<PersonalStatistics />} />
          <Route path="/info" element={<Information />} />
          <Route path="/terms-of-use" element={<Information />} />
          <Route path="/user-conditions" element={<Information />} />
          <Route path="*" element={<Error />} />
        </Route>
      </Routes>
    </div>
  );
}

export default Root;
